import { render, staticRenderFns } from "./BtnAtivarDesativar.vue?vue&type=template&id=71c63343&scoped=true"
import script from "./BtnAtivarDesativar.vue?vue&type=script&lang=js"
export * from "./BtnAtivarDesativar.vue?vue&type=script&lang=js"
import style0 from "./BtnAtivarDesativar.vue?vue&type=style&index=0&id=71c63343&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c63343",
  null
  
)

export default component.exports